<template>
  <v-select
    v-bind="$attrs"    
    :items="categories"
    :value="value"
    @input="selectChange"
  ></v-select>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: "ServiceCategorySelect",

  props: ['value', 'preloaded'],
  
  computed: {
    ...mapGetters('services', ['categories'])
  },

  methods: {
    ...mapActions('services', ['loadServices']),
    selectChange(newVal) {
      this.$emit('input', newVal)
    },
  },

  created() {
    if (!this.preLoaded) { 
      this.loadServices()
    }
  },
}

</script>